import { useRPCQuery } from "eddev/hooks"
import { useHydrating } from "eddev/routing"
import { useMemo } from "react"

export function useEventManifest() {
  return useRPCQuery("api.ticketing.ticketManifest", undefined, {
    structuralSharing: true,
    staleTime: 60_000,
  })
}

export function useSpektrixSessions(eventIds: number | number[]) {
  const manifest = useEventManifest()
  const hydrating = useHydrating()
  const sessions = useMemo(() => {
    const ids = new Set(Array.isArray(eventIds) ? eventIds : [eventIds])
    return manifest.data?.sessions.filter((session) => ids.has(session.eventId)) ?? []
  }, [manifest.data, eventIds])
  return { sessions, isSuccess: !hydrating && manifest.isSuccess, isError: !hydrating && manifest.isError }
}
